'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customCookies = _jsCookie2.default.withConverter({
  write: function write(value, key) {
    return value;
  },
  read: function read(value) {
    return value;
  }
});

customCookies.getPPU = function () {
  return this.get('PPU');
};
customCookies.getZZU = function () {
  return this.get('ZZU');
};
customCookies.getUID = function () {
  var uid = this.get('uid');
  if (!uid) {
    var ppu = customCookies.getPPU();
    if (ppu) {
      ppu = ppu.match(/UID=(\d+)/);
      if (ppu.length && ppu.length > 1) {
        uid = ppu[1];
      }
    }
  }
  return uid;
};
customCookies.getToken = function () {
  return this.get('tk');
};
customCookies.getPPUObject = function () {
  var ppu = this.get('ZZU') || this.get('PPU') || '';
  return (0, _utils.entriesToObject)(new URLSearchParams(ppu));
};

exports.default = customCookies;